import type { TimedHistoryEntry } from "@mk/shared";
import { timedShareResult } from "../features/share/shareText.ts";
import { messages } from "../i18n/index.ts";
import { formatDate } from "../lib/edition.ts";
import { ResultBoard } from "./ResultBoard.tsx";
import { ShareButton } from "./ShareButton.tsx";
import { Sheet } from "./Sheet.tsx";

export const TIMED_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
};

interface TimedRunReportProps {
  run: TimedHistoryEntry | null;
  onClose: () => void;
}

/** Bitmiş bir 3 dakika koşusunun raporu: her kelime, yazılan tüm tahminleriyle. */
export function TimedRunReport({ run, onClose }: TimedRunReportProps) {
  return (
    <Sheet open={run !== null} title={messages.solo.timedResultTitle} accent="amber" placement="center" onClose={onClose}>
      {run && <>
        <p className="text-sm text-muted">{formatDate(run.finishedAt, TIMED_DATE_OPTIONS)}</p>
        <div className="timed-result__count text-center">{run.wordsSolved}</div>
        <p className="text-center text-sm text-muted">{messages.solo.timedAttempts(run.solvedAttempts)}</p>
        {run.rounds.length === 0 && !run.unfinished
          ? <p className="mt-4 text-sm text-muted">{messages.solo.timedNoRounds}</p>
          : <div className="team-history-detail mt-5">
            {run.rounds.map((round) => <article key={round.wordIndex} data-team={round.solved ? undefined : "B"}><h3>{round.wordIndex + 1}. {round.answer}</h3><ResultBoard rows={round.guesses} /></article>)}
            {run.unfinished && <article data-unfinished="true">
              <h3>{run.unfinished.wordIndex + 1}. {run.unfinished.answer}</h3>
              <p>{messages.solo.timedUnfinished(run.unfinished.guesses.length)}</p>
              {run.unfinished.guesses.length > 0 && <ResultBoard rows={run.unfinished.guesses} />}
            </article>}
          </div>}
        {/* Geçmiş satırı o koşunun rekor olup olmadığını bilmiyor; rekor iddiası yalnızca sonuç ekranında. */}
        <div className="mt-5"><ShareButton rows={[]} result={timedShareResult(run, false)} /></div>
        <button type="button" className="btn-secondary mt-2 w-full" onClick={onClose}>{messages.common.close}</button>
      </>}
    </Sheet>
  );
}
